import React, { useEffect } from 'react';
import { ErrorPage } from '@src/shared/ui';
import { useGTM, useProposalState } from '@src/shared';
import { GTMEvents } from '@src/config/gtm';

export const IdwallReprovedPage: React.FC = () => {
  const { trackEvent } = useGTM();
  const { proposal } = useProposalState();

  useEffect(() => {
    trackEvent(GTMEvents.USER_REPROVED, {
      proposal_id: proposal.proposalId,
    });
  }, []);

  return (
    <ErrorPage
      title='Ops, não foi dessa vez'
      description='Infelizmente, você não pode pagar com o Boleto Parcelado PaGol no momento. Mas não se preocupe, você pode tentar novamente em 30 dias ou refazer seu pedido no site da GOL e escolher outra forma de pagamento.'
      backToGolButtonPrimary
    />
  );
};
